import React, { useState } from 'react';
import { SectionHeading } from '../SectionHeading';
import { Carousel } from '../Carousel';
import { ZoomablePage } from '../ZoomablePage';
import { Lightbox } from '../Lightbox/Lightbox';
import { INTERIOR_SAMPLES } from '../../data/collection';

/** Frame every sample at the tallest page ratio so cards share baselines; pages are contained, never cropped. */
const tallest = INTERIOR_SAMPLES.reduce((a, b) => b.height / b.width > a.height / a.width ? b : a);
const FRAME_RATIO = `${tallest.width} / ${tallest.height}`;
const lightboxItems = INTERIOR_SAMPLES.map(sample => ({
  src: sample.src,
  alt: sample.alt,
  file: sample.file,
  caption: `${sample.title} · ${sample.volume}, ${sample.model}`,
  width: sample.width,
  height: sample.height
}));
export function InteriorPagesSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="paginas" aria-labelledby="paginas-title" className="w-full bg-paper" data-id="element-228" data-mp="39ggwowhax4up">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-229" data-mp="39it9ywc46r1f">
        <SectionHeading id="paginas-title" title="Así son los manuales y moldes que recibís" intro="Cuatro páginas de otros volúmenes. Tocá cualquiera para verla completa." data-id="element-230" data-mp="f7qvomttv4yi" />

        <div className="mt-10" data-id="element-231" data-mp="o6uc1j1m169b">
          <Carousel items={INTERIOR_SAMPLES} label="Páginas interiores de la colección" grid="md-2-lg-4" getKey={sample => sample.file} renderItem={(sample, index) => <article className="flex w-full flex-col" data-id="element-233" data-mp="k5pul5kirmw">
                <ZoomablePage image={sample} label={`${sample.title} · ${sample.volume}, ${sample.model}`} onOpen={() => setOpen(index)} frameRatio={FRAME_RATIO} data-id="element-234" data-mp="5ipdqr3q2dhw" />
                <p className="mt-4 text-[0.88rem] font-bold text-sage-ink" data-id="element-235" data-mp="38ymop29pjpha">
                  {sample.volume} · {sample.model}
                </p>
                <h3 className="mt-1 font-serif text-[1.3rem] font-semibold leading-tight text-graphite" data-id="element-236" data-mp="l3imkm832lo8">{sample.title}</h3>
                <p className="mt-2 text-[1rem] leading-relaxed text-graphite-soft" data-id="element-237" data-mp="g5h4a3iheqdt">{sample.description}</p>
              </article>} data-id="element-232" data-mp="t7rsnr6z1s8p" />
        </div>
      </div>

      <Lightbox items={lightboxItems} index={open} onClose={() => setOpen(null)} onNavigate={setOpen} label="Páginas interiores" data-id="element-238" data-mp="puqzhs8mgp65" />
    </section>;
}